import script from "./tree-select.vue?vue&type=script&setup=true&lang=js"
export * from "./tree-select.vue?vue&type=script&setup=true&lang=js"

import "./tree-select.vue?vue&type=style&index=0&id=54bf4391&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\wisecard\\smart-tms-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54bf4391"]])

export default __exports__